import React from 'react';

interface StepProps {
	stepNumber: number;
	title: string;
	description: string;
}

const Step: React.FC<StepProps> = ({ stepNumber, title, description }) => {
	return (
		<div className="mt-10 max-w-full w-[1120px]">
			<div className="flex gap-5 max-md:flex-col max-md:gap-0">
				<div className="flex flex-col w-[58%] max-md:ml-0 max-md:w-full">
					<div className="flex flex-col text-white max-md:mt-10 max-md:max-w-full">
						<div className="flex gap-5 font-bold max-md:flex-wrap">
							<div className="self-start text-6xl leading-10 text-center max-md:text-4xl">
								{stepNumber}.
							</div>
							<div className="self-end flex-auto text-5xl leading-10 max-md:max-w-full max-md:text-4xl">
								{title}
							</div>
						</div>
						<div className="self-end mt-3 text-2xl leading-10 max-md:max-w-full">
							{description}
						</div>
					</div>
				</div>
				<div className="flex flex-col ml-5 w-[42%] max-md:ml-0 max-md:w-full">
					<div className="shrink-0 mx-auto mt-11 max-w-full bg-zinc-300 h-[455px] w-[455px] max-md:mt-10" />
				</div>
			</div>
		</div>
	);
};

const Divider: React.FC = () => {
	return (
		<div className="shrink-0 mt-16 max-w-full bg-white border-2 border-white border-solid h-[3px] w-[1120px] max-md:mt-10" />
	);
};

interface InstructionSteps {
	steps: {
		stepNumber: number,
		title: string,
		description: string
	}[]
	heading: string
}


const Instructions = (props: InstructionSteps) => (

	<div className="flex flex-col items-center max-w-full px-5">
		<header className="flex justify-center items-center px-16 pt-5 pb-3 max-w-full text-4xl font-bold leading-10 text-center text-white w-[1120px] max-md:px-5">
			<h2 className="bg-clip-text max-md:max-w-full">
				{props.heading}
			</h2>
		</header>
		<Divider />
		{props.steps.map((step, index) => (
			<React.Fragment key={index}>
				<Step
					stepNumber={step.stepNumber}
					title={step.title}
					description={step.description}
				/>
				{index !== props.steps.length - 1 && <Divider />}
			</React.Fragment>
		))}
	</div>
)

export default Instructions